import React from 'react'

function Notification() {
  return (
    <div className="p-4 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-semibold text-[#2a3547] mb-4">Notifications</h2>

      {/* You can uncomment and customize this sample notification list if needed */}
      {/* 
      <div className="space-y-3">
        <div className="p-3 bg-[#fef2e7] rounded-md border-l-4 border-[#fc7e14]">
          <p className="text-[#2a3547]">New notification message</p>
          <span className="text-sm text-[#5a6a85]">2 minutes ago</span>
        </div>
        
        <div className="p-3 bg-white rounded-md border border-gray-200 hover:bg-[#fef2e7]">
          <p className="text-[#2a3547]">Another notification message</p>
          <span className="text-sm text-[#5a6a85]">Yesterday</span>
        </div>
      </div>
      */}
    </div>
  )
}

export default Notification

/*
  import React, { useState, useEffect } from 'react';
  import { BellRing, X, Check, ExternalLink } from "lucide-react";
  import Pagination from '../../utils/Pagenation/Pagenation';

  function Notification() {
    // Sample notifications data - you can replace this with actual API calls
    const [notifications, setNotifications] = useState([
      {
        id: 1,
        title: "New amenity added",
        message: "Swimming pool has been added to available amenities",
        timestamp: "10 minutes ago",
        type: "info",
        isRead: false
      },
      {
        id: 2,
        title: "System maintenance",
        message: "The system will be down for maintenance on Sunday from 2-4 AM",
        timestamp: "2 hours ago",
        type: "warning",
        isRead: false
      },
      {
        id: 3,
        title: "News published",
        message: "Community newsletter for May has been published",
        timestamp: "Yesterday",
        type: "success",
        isRead: true
      },
      {
        id: 4,
        title: "Payment reminder",
        message: "Amenity payment is due by the end of this month",
        timestamp: "3 days ago",
        type: "danger",
        isRead: true
      },
      {
        id: 5,
        title: "Welcome message",
        message: "Welcome to our community portal! Browse available amenities and stay up to date with news",
        timestamp: "1 week ago",
        type: "info",
        isRead: true
      }
    ]);

    // For pagination
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 3;
    const pageCount = Math.ceil(notifications.length / itemsPerPage);
    const currentNotifications = notifications.slice(
      currentPage * itemsPerPage,
      (currentPage + 1) * itemsPerPage
    );

    // Handle marking notification as read
    const handleMarkAsRead = (id) => {
      setNotifications(notifications.map(notification =>
        notification.id === id ? { ...notification, isRead: true } : notification
      ));
    };

    // Handle marking all as read
    const handleMarkAllAsRead = () => {
      setNotifications(notifications.map(notification => ({ ...notification, isRead: true })));
    };

    // Count unread notifications
    const unreadCount = notifications.filter(notification => !notification.isRead).length;

    // Get notification style based on type
    const getNotificationStyle = (type, isRead) => {
      const baseStyle = "p-4 rounded-md border-l-4 relative transition-all duration-200";

      if (isRead) {
        return `${baseStyle} bg-white border-gray-200 hover:bg-gray-50`;
      }

      switch (type) {
        case 'info':
          return `${baseStyle} bg-blue-50 border-blue-500`;
        case 'warning':
          return `${baseStyle} bg-yellow-50 border-yellow-500`;
        case 'danger':
          return `${baseStyle} bg-red-50 border-red-500`;
        case 'success':
          return `${baseStyle} bg-green-50 border-green-500`;
        default:
          return `${baseStyle} bg-blue-50 border-blue-500`;
      }
    };

    return (
      <div className="bg-gray-50 min-h-screen md:p-4">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
            <div className="flex justify-between items-center p-4 border-b border-gray-200">
              <div className="flex items-center">
                <BellRing className="h-6 w-6 text-blue-500 mr-2" />
                <h1 className="text-2xl font-bold text-gray-800">Notifications</h1>
                {unreadCount > 0 && (
                  <span className="ml-2 bg-blue-500 text-white text-xs font-medium rounded-full px-2 py-1">
                    {unreadCount} new
                  </span>
                )}
              </div>
              {unreadCount > 0 && (
                <button
                  className="text-sm text-blue-500 hover:text-blue-700 flex items-center"
                  onClick={handleMarkAllAsRead}
                >
                  <Check className="h-4 w-4 mr-1" />
                  Mark all as read
                </button>
              )}
            </div>

            <div className="divide-y divide-gray-200">
              {currentNotifications.length === 0 ? (
                <div className="p-6 text-center text-gray-500">
                  No notifications found
                </div>
              ) : (
                currentNotifications.map((notification) => (
                  <div
                    key={notification.id}
                    className={getNotificationStyle(notification.type, notification.isRead)}
                  >
                    <div className="flex justify-between">
                      <h3 className="font-medium text-gray-900">{notification.title}</h3>
                      <span className="text-xs text-gray-500">{notification.timestamp}</span>
                    </div>
                    <p className="mt-1 text-sm text-gray-600">{notification.message}</p>

                    {!notification.isRead && (
                      <button
                        className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
                        onClick={() => handleMarkAsRead(notification.id)}
                        title="Mark as read"
                      >
                        <Check className="h-4 w-4" />
                      </button>
                    )}

                    <div className="mt-2 flex justify-end">
                      <button className="text-xs text-blue-500 hover:text-blue-700 flex items-center">
                        View details
                        <ExternalLink className="h-3 w-3 ml-1" />
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>

            {notifications.length > itemsPerPage && (
              <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
                <div className="text-sm text-gray-700">
                  Page {currentPage + 1} of {pageCount}
                </div>
                <div className="flex-1 flex justify-end">
                  <Pagination
                    currentPage={currentPage}
                    pageCount={pageCount}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  export default Notification;

*/